import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
interface LoginState {
  phoneNumber?: string;
  loginState: "phone-number" | "otp";
  id?: string;
  code?: string;
}

const initialState: LoginState = {
  loginState: "phone-number",
};

export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setPhoneNumber: (state, action: PayloadAction<string>) => {
      state.phoneNumber = action.payload;
    },
    setLoginState: (state, action: PayloadAction<"phone-number" | "otp">) => {
      state.loginState = action.payload;
    },
    setCode: (state, action: PayloadAction<string>) => {
      state.code = action.payload;
    },
    setId: (state, action: PayloadAction<string>) => {
      state.id = action.payload;
    },
    
  },
});
export const { setPhoneNumber, setLoginState, setCode, setId } =
  loginSlice.actions;
export default loginSlice.reducer;
